"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsAjaxCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {
      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();
        return false;
      });
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      updateProductProperties($addToCartForm.find('.quantity-input'));
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      var itemKey = $(this).data('cart-item-key');
      
      var lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }
      shopify.cart.resetDefaultButton(itemKey);

      return false;
    });
    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();
      return false;
    });
    
    $(document).on("change",'.ajax-cart__quantity-box .quantity-input',function(){
      var quantity = $(this).val();
      if(quantity>=1){
      	var id = $(this).data('key');
      	Shopify.theme.jsAjaxCart.updateQuantity(id,quantity,$(this));
      }else{
      	$(this).val(1);
      }
      
    });
    
    $(document).on("click",".drawer-upsel-add-cart-btn",function(){
    	Shopify.theme.jsAjaxCart.upsellProductAdd($(this));
    });
  },
  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $('[data-ajax-cart-trigger]');
    $el.hover(function () {
      if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function () {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != 'mini_cart') return false;
    var $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $('.mobile-header [data-ajax-cart-trigger]'); // Removes url to the cart page so user is not redirected

    $el.attr('href', '#');
    $el.off('click').on('click', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      } // Loads content into ajaxCart container for mobile header


      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      $el.toggleClass('show-mini-cart'); // Calculate height of mini cart

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt($('.mobile-header').height());

      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      $('.mobile-header .theme-ajax-cart').css({
        height: "calc(100vh - ".concat(mobileHeaderHeight + announcementHeight, "px)")
      });
    });
  },
  showDrawer: function showDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    Shopify.theme.jsAjaxCart.initializeUpsellSlider();
  },
  hideDrawer: function hideDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  upsellProductAdd:function upsellProductAdd($button){
    var data={
      quantity:1,
      id: $button.data('id')
      
    };
    
    
  	 $.ajax({
          type: "POST",
          url: "/cart/add.js",
          async: false,
          cache: false,
          data: data,
          dataType: "json",
          success: function (data) {
            //Shopify.theme.jsAjaxCart.showDrawer();
        	Shopify.theme.jsAjaxCart.updateView();
          },
          error: shopify.collection.samples.failed
     });
  },
  initializeUpsellSlider: function initializeUpsellSlider(){
    /*$('.main-carousel').flickity('destroy');
  	var $carousel = $('.main-carousel').flickity({
      imagesLoaded: true,
      contain: true,
      percentPosition: true,
      initialIndex: 2,
      wrapAround: true
    });*/
    $('.main-gallery.js-flickity').flickity('destroy');
    if($('.main-gallery.js-flickity').hasClass('hidearrow')){
    	$('.main-gallery.js-flickity').flickity({
        // options
        cellAlign: 'center',
        contain: true,
          prevNextButtons:false,
        arrowShape: 'M 95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46 Z'
      });
    }else{
      $('.main-gallery.js-flickity').flickity({
      // options
      cellAlign: 'center',
      contain: true,
      arrowShape: 'M 95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46 Z'
    });
    }
    
  },
  removeFromCart: function removeFromCart(lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function success(cart) {
        shopify.cart.sampleCostCheck();
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  initializeAjaxCart: function initializeAjaxCart() {
    console.log(Shopify.routes.cart_url);
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref) {
      var html = _ref.html,
          options = _ref.options;
      $('[data-ajax-cart-content]').html(html.content); // Converting the currencies

      if (Currency.show_multiple_currencies) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }
    }).fail(function () {// some error handling
    });
  },
  initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
    this.toggleMiniCart();
    Shopify.theme.asyncView.load("/cart", // template name
    'ajax' // view name (suffix)
    ).done(function (_ref2) {
      var html = _ref2.html,
          options = _ref2.options;
      $('.mobile-header [data-ajax-cart-content]').html(html.content);
    }).fail(function () {// some error handling
    });
  },
  addToCart: function addToCart($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function success(product) {
        var $el = $('[data-ajax-cart-trigger]');
        $addToCartBtn.find('.checkmark').addClass('checkmark-active');

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');
          $addToCartBtn.find('span').removeClass('fadeInDown');
        }
        if($addToCartForm.find('.sample-button').length >0){
        	var message = $addToCartForm.find('.sample-button').attr('data-message');
          intervalTime = 1000;
              shopify.helpers.notice('<h5><b>'+message+'</b></h5>');
        }
		
        
        window.setTimeout(function () {
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
          $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        }, 1000);
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        if (Shopify.theme.jsCart) {
          var _$$ajax;

          $.ajax((_$$ajax = {
            dataType: "json",
            async: false,
            cache: false
          }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
            var cartForm = $(html).find('.cart__form');
            $('.cart__form').replaceWith(cartForm);
          }), _$$ajax));
        }
      },
      error: function error(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
        $('.warning').remove();
        $addToCartForm.find('.cart-warning').html(cartWarning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
        $addToCartBtn.find('.text').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');
      }
    });
  },
  updateQuantity: function updateQuantity(id,quantity,el){
    var valMax = 100000000000000000;
    var valMin = el.attr('min') || 0;

    if (el.attr('max') != null) {
      valMax = el.attr('max');
    }

    if (isNaN(quantity) || quantity < valMin) {
      el.val(valMin);
      return false;
    } else if (quantity > valMax) {
      el.val(valMax);
      return false;
    }
    var dataObject = {'id':id,'quantity':quantity};
    var qty = parseInt(quantity);
    var product_type = el.data("protype");
    var l = qty/2;
    var l2 = qty/1.9;
    var propertyObject = el.parents('div.ajax-cart__product-content').find('.ajax-cart__quantity-warning');
    if(product_type == "Vinyl Flooring"){
      if(l<5){
        dataObject = {
          quantity: qty,
          id: id,
          properties: {
            'You will receive': 'You will receive a roll of vinyl 2m wide and '+ l.toFixed(2) +'m long.'
          }
        }
        propertyObject.html('You will receive a roll of vinyl 2m wide and '+ l.toFixed(2) +'m long.');
      }
      if(l>=5 && l<50){
        dataObject = {
          quantity: qty,
          id: id,
          properties: {
            'You will receive': ''
          }
        }  

        propertyObject.html('');
      }
      if(l>=50){

        dataObject = {
          quantity: qty,
          id: id,
          properties: {
            'You will receive': 'Please note a full roll of vinyl is 50 sq m, your order will be supplied in more than one piece.'
          }
        }
        propertyObject.html('Please note a full roll of vinyl is 50 sq m, your order will be supplied in more than one piece.');
      }                

    }
    else if(product_type == "Okofloor"){

      if(l<5){


        dataObject = {
          quantity: qty,
          id: id,
          properties: {
            'You will receive': 'You will receive a roll of oko 2m wide and '+ l.toFixed(2) +'m long.'
          }
        }                
		propertyObject.html('You will receive a roll of oko 2m wide and '+ l.toFixed(2) +'m long.');
        
      }
      if(l>=5 && l<50){


        dataObject = {
          quantity: qty,
          id: id,
          properties: {
            'You will receive': ''
          }
        } 
		propertyObject.html('');
        
      }
      
      if(l>=50){



        dataObject = {
          quantity: qty,
          id: id,
          properties: {
            'You will receive': 'Please note a full roll of oko is 50 sq m, your order will be supplied in more than one piece.'
          }
        }                 
		propertyObject.html('Please note a full roll of oko is 50 sq m, your order will be supplied in more than one piece.');
      }                

    }
    else if(product_type == "Rubber Flooring"){

      if(l2<5)
      {

        dataObject = {
          quantity: qty,
          id: id,
          properties: {
            'You will receive': 'You will receive a roll of rubber 1.9m wide and  '+ l2.toFixed(2) +'m long.'
          }
        }                 
		propertyObject.html('You will receive a roll of rubber 1.9m wide and '+ l2.toFixed(2) +'m long.');
      }

      if(l2 >= 5 && l2 < 19)
      {

        dataObject = {
          quantity: qty,
          id: id,
          properties: {
            'You will receive': ''
          }
        }
		propertyObject.html('');
     
      }

      if(l2 >= 19)
      {


        dataObject = {
          quantity: qty,
          id: id,
          properties: {
            'You will receive': 'Please note a full roll of rubber is 19 sq m, your order will be supplied in more than one piece.'
          }
        }
		propertyObject.html('Please note a full roll of rubber is 19 sq m, your order will be supplied in more than one piece.');
      }              

    }     
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: dataObject,
      dataType: 'json',
      success: function success(cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {

      }
    });
  },
  updateView: function updateView() {
    Shopify.theme.asyncView.load("/cart", // template name
    'ajax' // view name (suffix)
    ).done(function (_ref3) {
      var html = _ref3.html,
          options = _ref3.options;

      if (options.item_count > 0) {
        var itemList = $(html.content).find('.ajax-cart__list');
        var cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (Currency.show_multiple_currencies) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }
      setTimeout(function(){
      	Shopify.theme.jsAjaxCart.initializeUpsellSlider();
      },100);
    }).fail(function () {// some error handling
    });
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
};